<template>
  <v-container fluid class="notification-page px-2">
    <empty-message :show="!showNotifications" message="No new notifications, please wait" />
    <v-layout
      wrap
      class="notification-page__notifications"
      v-if="showNotifications"
    >
      <v-flex xs12 class="text-xs-right">
        <v-btn small outline color="error" @click="clearAll()">
          Clear All
        </v-btn>
      </v-flex>
      <v-flex
        d-flex
        xs12
        md4
        lg3
        v-for="(message, idx) in notifications"
        :key="`notifications--${message.id}`"
        class="pa-2 animation-item-list"
        :style="{ 'animation-delay': idx / 50 + 's' }"
      >
        <notification-card :message="message" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NotificationCard from "./NotificationCard.vue";
import EmptyMessage from "@/components/EmptyMessage";

export default {
  name: "Notifications",
  components: {
    EmptyMessage,
    NotificationCard,
  },
  methods: {
    clearAll() {
      this.$store.commit("clearNotifications");
    },
  },
  computed: {
    notifications() {
      let notifications = [];
      const results = this.$store.getters.notifications;
      for (const key in results) {
        notifications.push(results[key]);
      }
      notifications
        .sort((a, b) => {
          let d1 = a.timestamp;
          let d2 = b.timestamp;
          if (d1 > d2) return -1;
          if (d1 < d2) return 1;
          return 0;
        })
      return notifications;
    },
    showNotifications() {
      return Object.keys(this.notifications).length > 0;
    },
  },
  // destroyed() {
  //   this.$store.commit("resetNotificationCount");
  // },
};
</script>

<style>
.notification-page {
  height: 100% !important;
}
.animation-item-list {
  animation-name: fadeInOut;
  animation-duration: 150ms;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
}
@keyframes fadeInOut {
  0% {
    transform: translateY(-70px);
    visibility: hidden;
  }
  50% {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>